<script>
import Footer from "../components/Footer.svelte";
import HeaderSignedIn from "../components/header/HeaderSignedIn.svelte";
import Modals from "../components/Modals.svelte";
import TopbarSignedIn from "../components/TopbarSignedIn.svelte";
import ModalCarousel from "../components/product-item/ModalCarousel.svelte";
import Breadcrumbs from "../components/Breadcrumbs.svelte";
import PriceStatus from "../components/product-item/PriceStatus.svelte";
import Spec from "../components/product-item/Spec.svelte";
import Document from "../components/product-item/Document.svelte";
import InfoItem from "../components/product-item/InfoItem.svelte";
import NavTabs from "../components/nav-tabs/NavTabs.svelte";
import Video from "../components/product-item/Video.svelte";

let elslutbleck = {
  title: "Elslutbleck Step 90 Release Omställbar 24V Kolvkontakt",
  info: {
    article: "152090",
    brand: "Safetron",
    surface: "Rostfri",
  },
};
</script>

<div
  class="container"
  id="wrapper"
  data-event="productDetail"
  data-article-number="123"
  data-name="productname"
  data-brand="brandname"
  data-category="top level category"
  data-price="123,15"
>
  <TopbarSignedIn />
  <HeaderSignedIn />
  <Breadcrumbs />
  <div class="row">
    <div class="col-xs-12">
      <h1 class="mb-md">{elslutbleck.title}</h1>
      <div class="visible-xs">
        <div class="relative">
          <script>
          $(document).ready(function () {
            inject_orbitvu(
              "presentation65-container",
              "./themes/gothes/dist/orbitvu-3.9.1/orbitvu.js",
              "",
              {
                ovus_folder:
                  "/public/images/ftg10/img1000x1000/152090_17971.jpg",
                content2: "yes",
                width: "100%",
                height: "400",
              }
            );
          });
          </script>
          <div class="row">
            <div class="col-xs-12 col-md-12">
              <div class="relative">
                <div class="thumbnail article-image relative">
                  <a
                    id="zoomBtn"
                    href="https://shopgib.gothes.se/public/images/ftg10/img1000x1000/153037_18366.jpg"
                    class="btn btn-default mb-xs absolute pin-right pin-bottom hidden-xs btn-zoom-img-carousel"
                    data-toggle="modal"
                    data-target=".modal-carousel-image-large"
                    style="max-width: 120px;z-index: 10;bottom: 70px; display:none;"
                  >
                    <span class="glyphicon glyphicon-fullscreen"></span>
                  </a>
                  <div
                    id="carousel-product-images"
                    class="carousel"
                    data-interval="false"
                  >
                    <!-- Wrapper for slides -->
                    <div class="carousel-inner" role="listbox">
                      <div class="item active">
                        <div>
                          <img
                            src="https://shopgib.gothes.se/public/images/ftg10/img1000x1000/153037_18366.jpg"
                            data-zoom="https://shopgib.gothes.se/public/images/ftg10/img1000x1000/153037_18366.jpg"
                            alt="Produktbild"
                          />
                        </div>
                      </div>

                      <div class="item">
                        <div>
                          <img
                            src="https://shopgib.gothes.se/public/images/ftg10/img320x320/153037_16749.jpg"
                            data-zoom="https://shopgib.gothes.se/public/images/ftg10/img1000x1000/153037_16749.jpg"
                            alt="Produktbild"
                          />
                        </div>
                      </div>

                      <div class="item">
                        <div>
                          <img
                            src="https://shopgib.gothes.se/public/images/ftg10/img320x320/153037_18359.jpg"
                            data-zoom="https://shopgib.gothes.se/public/images/ftg10/img1000x1000/153037_18359.jpg"
                            alt="Produktbild"
                          />
                        </div>
                      </div>
                    </div>

                    <!-- Indicators -->
                    <ol class="carousel-indicators">
                      <li
                        data-target="#carousel-product-images"
                        data-slide-to="0"
                        class="active"
                      >
                        <img
                          data-zoom=""
                          src="https://shopgib.gothes.se/public/images/ftg10/img1000x1000/153037_18366.jpg"
                          alt="Tumnagel"
                        />
                      </li>

                      <li
                        data-target="#carousel-product-images"
                        data-slide-to="1"
                      >
                        <img
                          data-zoom=""
                          src="https://shopgib.gothes.se/public/images/ftg10/img50x50/153037_16749.jpg"
                          alt="Tumnagel"
                        />
                      </li>

                      <li
                        data-target="#carousel-product-images"
                        data-slide-to="2"
                      >
                        <img
                          data-zoom=""
                          src="https://shopgib.gothes.se/public/images/ftg10/img50x50/153037_18359.jpg"
                          alt="Tumnagel"
                        />
                      </li>
                    </ol>

                    <!-- Controls -->

                    <a
                      class="left carousel-control"
                      href="#carousel-product-images"
                      role="button"
                      data-slide="prev"
                    >
                      <span
                        class="btn-border"
                        style="
                position:relative;
                top: calc(42%);
                margin-left: -0.25rem;"
                        aria-hidden="true"
                      ><svg
                          width="9"
                          height="14"
                          viewBox="0 0 9 14"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M8 1L2 7L8 13"
                            stroke="#2751BC"
                            stroke-width="2"
                            stroke-linecap="round"
                          ></path>
                        </svg>
                      </span>
                      <span class="sr-only">Previous</span>
                    </a>
                    <a
                      class="right carousel-control"
                      href="#carousel-product-images"
                      role="button"
                      data-slide="next"
                    >
                      <span
                        class="btn-border"
                        style="
            position:relative;
            top: calc(42%);"
                        aria-hidden="true"
                      ><svg
                          width="9"
                          height="14"
                          viewBox="0 0 9 14"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M1 1L7 7L0.999999 13"
                            stroke="#2751BC"
                            stroke-width="2"
                            stroke-linecap="round"
                          ></path>
                        </svg>
                      </span>
                      <span class="sr-only">Next</span>
                    </a>
                  </div>
                </div>
                <div
                  class="modal fade modal-carousel-image-large"
                  tabindex="-1"
                  role="dialog"
                  aria-labelledby=""
                  aria-hidden="true"
                >
                  <div class="modal-dialog modal-md">
                    <div class="modal-content">
                      <div class="modal-header">
                        <button
                          type="button"
                          class="close"
                          data-dismiss="modal"
                          aria-label="Close"
                        ><span aria-hidden="true">&times;</span></button>
                        <h4 class="modal-title">
                          ELTRYCKESLÅS SL620 RV SATS SAFETRON
                        </h4>
                      </div>
                      <div class="modal-body">
                        <img
                          id="zoomImage"
                          class="img-responsive"
                          src="https://shopgib.gothes.se/public/images/ftg10/img1000x1000/153037_18366.jpg"
                          style="margin: 0 auto; max-height: 700px"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-xs-12 col-md-6 item-border">
        <div id="content" class="main-content">
          <div class="item-card-container">
            <PriceStatus />
            <Spec />
            <Document />
            <InfoItem />
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-xs-12 col-md-6 modal-carousel">
          <ModalCarousel />
          <Video />
        </div>
      </div>
    </div>
  </div>
  <div class="row" data-event="productImpression">
    <div class="col-xs-12">
      <NavTabs />
    </div>
  </div>
</div>
<Footer />
<Modals />
